"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("../Error/WidgetError");
/**
 * The extandble provider.
 */
class ExtendableProvider {
    /**
     * Constructs extendable manager.
     *
     * @param {*} extendables
     */
    constructor(extendables) {
        this.extendables = extendables;
    }
    /**
     * Gets the extended / base class.
     *
     * @param {*} base
     *   The base class for which to get.
     *
     * @return {*}
     *   The extension of base or the base if not found.
     */
    getExtended(base) {
        let ext = this.extendables.find(([b]) => b === base);
        if (!ext) {
            throw new WidgetError_1.default(`Extendable for '${base.constructor.name}' does not exist.`);
        }
        return ext[1];
    }
}
exports.default = ExtendableProvider;
